import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/resource-platform/page.tsx");
